2<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <div slot="header">
              {{$t('client.list')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in order.list" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="order.list[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.basic_information')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in order.basic_info" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="order.basic_info[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6" v-if="!without_disable.includes(option.type)">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="order.basic_info[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-bind:label="$t('client.cancel')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.cancel" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.complete')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.complete" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.proceed')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.proceed" :value="true" :uncheckedValue="false"/>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.customization')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <customization v-model="order.fields" :position_fields="position_fields"></customization>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'

  export default {
    name: 'CouponForm',
    props: {
      value: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        without_disable: [
          'external_coupon_upload',
          'ges_coupon_flag',
          'sale_channel',
          'sequence',
          'can_use_direct',
          'by_pass_min_cart',
          'ala_carte_min_cart',
          'single_use_coupon_login',
        ],
        position_fields: [
          'name_seo',
          'code',
          'display_date',
          'properties'
        ],
        order: {
          basic_info: [
            {
              'name': 'Receipt Code',
              'type': 'code',
              'show': true,
              'disable': true
            },
            {
              'name': 'Receipt Name',
              'type': 'receipt_name',
              'show': true,
              'disable': true
            },
            {
              'name': 'Hide from UI',
              'type': 'is_show',
              'show': true,
              'disable': true
            },
            {
              'name': 'External Coupon Upload',
              'type': 'external_coupon_upload',
              'show': false,
              'disable': true
            },
            {
              'name': 'GES Coupon Flag',
              'type': 'ges_coupon_flag',
              'show': false,
              'disable': true
            },
            {
              'name': 'Sequence',
              'type': 'sequence',
              'show': false,
              'disable': false
            },
            {
              'name': 'Sale Channel Flag',
              'type': 'sale_channel',
              'show': false,
              'disable': true
            },
            {
              'name': 'Can Use Direct',
              'type': 'can_use_direct',
              'show': false,
              'disable': true
            },
            {
              'name': 'By pass min Cart',
              'type': 'by_pass_min_cart',
              'show': false,
              'disable': true
            },
            {
              'name': 'Only apply for Ala Carte products',
              'type': 'ala_carte_min_cart',
              'show': false,
              'disable': true
            },
            {
              'name': 'Single Use Coupon Login',
              'type': 'single_use_coupon_login',
              'show': false,
              'disable': true
            }
          ],
          list: [
            // {
            //   'name': 'Order Reference',
            //   'type': 'order_reference',
            //   'show': true
            // },
          ],
          config: {
          },
          fields: []
        }
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }

          for (let i in this.order.basic_info) {
            if (basicInfo[this.order.basic_info[i].type] != null) {
              this.order.basic_info[i].show = basicInfo[this.order.basic_info[i].type].show
              this.order.basic_info[i].disable = basicInfo[this.order.basic_info[i].type].disable
            }
          }
        }

        // Update List Info
        if (this.value != null && this.value.list != null) {
          let basicInfo = {}
          for (let i in this.value.list) {
            basicInfo[this.value.list[i].type] = {
              show: this.value.list[i].show,
              disable: this.value.list[i].disable
            }
          }

          for (let i in this.order.list) {
            if (basicInfo[this.order.list[i].type] != null) {
              this.order.list[i].show = basicInfo[this.order.list[i].type].show
              this.order.list[i].disable = basicInfo[this.order.list[i].type].disable
            }
          }
        }

        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.order.config) {
            if (this.value.config[i] != null) {
              this.order.config[i] = this.value.config[i]
            }
          }
        }

        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.order.fields = this.value.fields
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      order: {
        handler: function (newValue) {
          this.$emit('input', this.order)
          this.$emit('change', this.order)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/CouponForm.vue